<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Grupos de Usuários</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <template #extra>
                        <a-button :icon="h(PlusOutlined)" @click="newRegister">Novo Registro</a-button>
                    </template>
                    <br><br>

                    <a-table :columns="columns" :data-source="dataSource" bordered>
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'acao'">
                                <a-button type="primary" shape="circle" @click="update(record)">
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Alterar</template>
                                            <FormOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>
                                <a-button type="primary"
                                          danger
                                          shape="circle"
                                          @click="destroy(record)"
                                >
                                    <template #icon>
                                        <a-tooltip>
                                            <template #title>Excluir</template>
                                            <DeleteOutlined />
                                        </a-tooltip>
                                    </template>
                                </a-button>
                            </template>
                        </template>
                    </a-table>
                </a-card>
            </a-config-provider>
        </a-spin>
    </div>
</template>
<script setup>
import { ref, h, onMounted } from 'vue';
import { PlusOutlined, FormOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import { notification } from 'ant-design-vue';
import { openNotification } from '../../../../utils/utilities';

const dataSource = ref();
const currentLocale = ref(ptBR);
const spinning = ref(false);

const route = '/api/configurations/users-groups';

const columns = ref(
    [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 50,
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ]
);

const update = (data) => {
    window.location.href = `users-groups/${data.id}/edit`;
}

const newRegister = () => {
    window.location.href = "users-groups/create"
}


onMounted(async () => {
    await load();
});

const load = async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
}


const destroy = async (data) => {
    try {
        const response =  await window.axios.delete(route + `/${data.id}`);
        openNotification('success', response.data.message)
        load();
    } catch (error) {
        openNotification('error', error.message)
    }
}
</script>

<style scoped>
.anticon {
    vertical-align: 2px !important;
}
</style>
